import { useState } from 'react';
import { api } from '../../lib/api';
import { useLogout } from '../../lib/session';
import { Dialog, ErrorMessage, Field } from '../../components/ui';

/** GDPR: download all personal data (art. 15/20) and delete the account (art. 17). */
export function PrivacySection() {
  const logout = useLogout();
  const [open, setOpen] = useState(false);
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState<unknown>(null);

  return (
    <section className="card" aria-labelledby="privacy-title">
      <h2 id="privacy-title">Moje dane</h2>
      <p>Możesz pobrać wszystkie dane, które przechowujemy o Tobie (plik JSON), albo usunąć konto.</p>
      <div className="button-row">
        <a className="button secondary" href="/api/v1/account/export" download>
          Pobierz moje dane
        </a>
        <button type="button" className="danger" onClick={() => setOpen(true)}>
          Usuń konto
        </button>
      </div>
      <Dialog open={open} title="Usunąć konto?" onClose={() => setOpen(false)}>
        <p>
          Przyszłe wizyty zostaną odwołane, a Twoje dane logowania usunięte. Historia wizyt i rozmów stanowi dokumentację medyczną:
          przechowujemy ją bez danych identyfikujących przez okres wymagany prawem, a potem usuwamy.
        </p>
        <Field label="Wpisz USUŃ, aby potwierdzić" name="confirmation" value={confirmation} onChange={setConfirmation} required />
        <ErrorMessage error={error} />
        <div className="button-row">
          <button
            type="button"
            className="danger"
            disabled={confirmation.trim() !== 'USUŃ'}
            onClick={() => {
              api.post('/api/v1/account/delete', { confirmation }).then(() => logout(), setError);
            }}
          >
            Usuń konto na stałe
          </button>
          <button type="button" className="secondary" onClick={() => setOpen(false)}>
            Anuluj
          </button>
        </div>
      </Dialog>
    </section>
  );
}
